<app-master-detail-crud
  [modelType]="modelType"
  [apiEndpointRoot]="apiEndpointRoot"
  [apiEndpointPOSTTemplate]="apiEndpointPOSTTemplate"
  [formTitle]="formTitle"
  [formSubtitle]="formSubtitle"
  [tableTitle]="tableTitle"
  [tableSubtitle]="tableSubtitle"
>
</app-master-detail-crud>
